/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * List of check-in statuses.
 */
export enum FinnairCheckInStatus {
  NOT_CHECKED_IN = 'NOT_CHECKED_IN',
  CHECKED_IN = 'CHECKED_IN',
  STANDBY = 'STANDBY'
}

